(() => {
  const easeOutCubic = t => {
    const t1 = t - 1;
    return t1 * t1 * t1 + 1;
  };

  // init hamburgers
  let countedUp = false;
  const topnav = document.querySelector("#topnav");
  const hamburger = document.querySelector(".hamburger");
  const hamburger_inner = document.querySelector(".hamburger-inner");
  hamburger.addEventListener("click", () => {
    [topnav, hamburger, hamburger_inner].map(el =>
      el.classList.toggle("is-active")
    );
  });

  // init accordions
  const accordions = document.querySelectorAll(".accordion");
  accordions.forEach(a => {
    a.addEventListener("click", () => {
      a.classList.toggle("open");
    });
  });

  /* sticky header */
  // add .stuck to section.sticky-top when user has scrolled more than 35px
  const evalScrollY = () => {
    const stickyHeader = document.querySelector(".sticky-top");
    if (window.scrollY > 35) {
      stickyHeader.classList.add("stuck");
    } else {
      stickyHeader.classList.remove("stuck");
    }
  };
  window.addEventListener("scroll", evalScrollY);

  /* Fade + slide in images */
  // test to see if the element is visible in the viewport
  const isElementInViewport = el => {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.top <
        (window.innerHeight * 0.7 ||
          document.documentElement.clientHeight * 0.7)
    );
  };

  const checkViewport = el => {
    const bubbles = el.querySelectorAll("[data-num]");
    if (isElementInViewport(el)) {
      el.classList.add("done");
    }
    if (bubbles.length && isElementInViewport(el) && !countedUp) {
      bubbles.forEach(val => {
        const finalValue = parseInt(val.dataset.num, 10);
        const animTime = parseInt(val.dataset.time, 10);
        const initTime = performance.now();

        // Interval
        let interval = setInterval(function () {
          let t = (performance.now() - initTime) / animTime;

          let currentValue = Math.floor(easeOutCubic(t) * finalValue);
          val.innerText = currentValue;

          if (t >= 1) {
            clearInterval(interval);
          }
        }, 50);
      });
      countedUp = true;
    }
    return;
  };

  /*!
   * Run a callback function after scrolling has stopped
   * (c) 2017 Chris Ferdinandi, MIT License, https://gomakethings.com
   * @param  {Function} callback The callback function to run after scrolling
   * @param  {Integer}  refresh  How long to wait between scroll events [optional]
   */
  const scrollStop = (callback, el, refresh = 66) => {
    // Make sure a valid callback was provided
    if (!callback || typeof callback !== "function") return;

    // Setup scrolling variable
    let isScrolling;

    // Listen for scroll events
    window.addEventListener(
      "scroll",
      function (event) {
        // Clear our timeout throughout the scroll
        window.clearTimeout(isScrolling);

        // Set a timeout to run after scrolling ends
        isScrolling = setTimeout(callback, refresh, el);
      },
      false
    );
  };

  // init images on scroll
  const allFadeSlideIns = document.querySelectorAll(
    ".fade-slide-in:not(.tab, .tab-explanation, .tabs-container, #questionnaire-result)"
  );
  const arr = [...allFadeSlideIns];
  if (arr.length) {
    arr.forEach(el => {
      checkViewport(el);
      scrollStop(checkViewport, el);
    });
  }

  /* fade in components from query params */
  const url = new URL(location.href);
  const elementToShow = url.searchParams.get("show");
  const element = document.querySelector(`.${elementToShow}`);
  if (element) {
    element.classList.add("done");
  }
})();
